module.exports = __webpack_public_path__ + "static/import1-min-66ab0296ab4c9b001051614b6e7af08b.png";